var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"px-3",attrs:{"outline":"","round":"","color":"msr","loading":_vm.deactivating,"data-cy":"deactivate-campaign-btn"},on:{"click":function($event){_vm.$emit('click')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("\n      block\n    ")]),_vm._v("\n    "+_vm._s(_vm.$t('deactivate'))+"\n  ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CampaignDeactivationButton.vue?vue&type=template&id=2a9b477a&
// module id = 1951
// module chunks = 5